module.exports = __webpack_public_path__ + "img/1478921339.406bbc97.jpg";